export function sumAmounts<T extends { add(value: T): T }>(arr: T[], initial: T) {
  return arr.reduce((acc, cur) => acc.add(cur), initial);
}
